import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_CONFIG from '../../config/api';

// Async thunks
export const verifyOtp = createAsyncThunk(
  'otp/verifyOtp',
  async ({ email, otp, mode }, { rejectWithValue }) => {
    try {
      const endpoint = mode === 'verify' ? 'verifyotp' : 'check-otp';
      const response = await axios.post(`${API_CONFIG.BASE_URL}/${endpoint}`, {
        email,
        otp,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to verify OTP'
      );
    }
  }
);

export const resetPassword = createAsyncThunk(
  'otp/resetPassword',
  async ({ email, password, password_confirmation }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_CONFIG.BASE_URL}/reset-password`,
        {
          email,
          password,
          password_confirmation,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to reset password'
      );
    }
  }
);

export const resendOtp = createAsyncThunk(
  'otp/resendOtp',
  async ({ email }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_CONFIG.BASE_URL}/forgot-password`,
        {
          email,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to resend OTP'
      );
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  successMessage: null,
  isOtpVerified: false,
  isPasswordReset: false,
};

const otpSlice = createSlice({
  name: 'otp',
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.error = null;
      state.successMessage = null;
    },
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.successMessage = null;
      state.isOtpVerified = false;
      state.isPasswordReset = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // Verify OTP
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.isOtpVerified = true;
        state.successMessage = action.payload.message;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Reset Password
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.isPasswordReset = true;
        state.successMessage = action.payload.message;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Resend OTP
      .addCase(resendOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(resendOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload.message;
      })
      .addCase(resendOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearErrors, resetState } = otpSlice.actions;
export default otpSlice.reducer;
